import type { FunctionComponent, MutableRefObject } from 'react';

import {
  Field,
  Form,
  ModalContainer,
  ModalLayoutCenter,
} from '@kanda-libs/ks-component-ts';
import { Button, Loader } from '@kanda-libs/ks-design-library';

import { MODAL_COPY, MODAL_ID } from 'components/job/JobRevertModal/constants';
import useJobRevertModalProps from 'components/job/JobRevertModal/useJobRevertModalProps';

import { MARK_COMPLETE_MODAL_ID } from './constants';

export interface MarkCompleteModalProps {
  callback: () => void;
  isSubmitting: boolean;
}

const MarkCompleteModal: FunctionComponent<MarkCompleteModalProps> = function ({
  callback,
  isSubmitting,
}) {
  return (
    <ModalContainer id={MARK_COMPLETE_MODAL_ID} opacity={30}>
      {({ handleClose, ref }) => (
        <>
          <ModalLayoutCenter
            id="staff-revert-job-modal"
            onClose={() => {
              handleClose();
            }}
            ref={ref as MutableRefObject<HTMLDivElement>}
            className="w-10/12 md:w-160"
          >
            <div className="flex flex-col">
              <span className="mb-6 text-16-20-em">
                Mark this job as complete?
              </span>
              <span className="mb-4">
                Are you sure you want to mark this job as complete?
              </span>
              <Button.Text
                id="staff-complete-job"
                label="Yes"
                onClick={callback}
                disabled={isSubmitting}
              />
            </div>
          </ModalLayoutCenter>
        </>
      )}
    </ModalContainer>
  );
};

export default MarkCompleteModal;
